export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE'
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'

// Resets the currently visible error message.
export const resetErrorMessage = () => ({
    type: RESET_ERROR_MESSAGE
})

export const setErrorMessage = (message) => ({
	type: SET_ERROR_MESSAGE,
	error: message
})

export const SET_PAYPAL_SDK_LOADED = 'SET_PAYPAL_SDK_LOADED'
export const SET_PAYPAL_SDK_ERROR = 'SET_PAYPAL_SDK_ERROR'

export const setPayPalSdkLoaded = (loaded) => ({
	type: SET_PAYPAL_SDK_LOADED,
	response: loaded
})

export const setPayPalSdkError = (error) => ({
	type: SET_PAYPAL_SDK_ERROR,
	response: error
})

export const SET_TIMED_OUT = 'SET_TIMED_OUT'
export const SET_TIMED_OUT_LOGGED_OUT = 'SET_TIMED_OUT_LOGGED_OUT'

export const setTimedOut = (timedOut) => ({
	type: SET_TIMED_OUT,
	response: timedOut
})

export const setTimedOutLoggedOut = (loggedOut) => ({
	type: SET_TIMED_OUT_LOGGED_OUT,
	response: loggedOut 
})

export const SET_SENDING = 'SET_SENDING'

export const setSending = (sending) => ({
	type: SET_SENDING,
	response: sending
})

export const SET_COVID_NOTICE_DISMISSED = 'SET_COVID_NOTICE_DISMISSED'
export const setCovidNoticeDismissed = (dismissed) => ({
	type: SET_COVID_NOTICE_DISMISSED,
	response: dismissed
})

export const SET_GENERAL_NOTICE_DISMISSED = 'SET_GENERAL_NOTICE_DISMISSED'
export const setGeneralNoticeDismissed = (dismissed) => ({
	type: SET_GENERAL_NOTICE_DISMISSED,
	response: dismissed
})